import styled, { css } from 'styled-components'

type IsMobileProps = {
  isMobile: boolean
}

export const Container = styled.div<IsMobileProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > button {
    margin-top: 25px;
    width: 100%;
    border-radius: 40px;
  }

  ${({ isMobile }) => isMobile && css`
    & > button {
      width: 90%;
    }
  `}
`

export const Grid = styled.div<IsMobileProps>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 34px);
  overflow-y: scroll;
  width: 300px;
  grid-gap: 10px;
  padding-right: 10px;
  overflow-x: hidden;
  height: 170px;

  &::-webkit-scrollbar {
    border-radius: 10px;
    height: 10px;
    width: 5px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  ${({ isMobile }) => isMobile && css`
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: auto;
    white-space: nowrap;
    padding: 0 20px;
    width: 100%;
    height: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      background: transparent;
      border-radius: 0;
    }
  `}
`